import React from "react";
import { Field } from "react-final-form";
import { TextFieldAdapter } from "@soqs/common";
const isAddress = (code) => {
  //Latin-1 without Appendix E
  const re = /^[ "A-Za-z0-9]{4,12}$/;
  return code && re.test(code)
    ? undefined
    : code === undefined || code?.length != 4
    ? "Postal code should contain a minimum of 4 and a maximum of 12 characters"
    : "Postal code should contain a minimum of 4 and a maximum of 12 characters";
};

const PostalCode = ({ ...rest }) => (
  <Field
    name="postalcode"
    validate={isAddress}
    label="Postal Code"
    autoComplete="postal-code"
    component={TextFieldAdapter}
    subscription={{ touched: true, value: true, error: true }}
    fullWidth
    inputProps={{ maxLength: 12 }}
    required
    {...rest}
  />
);

export default PostalCode;
